import React from "react";

import { Route } from "react-router-dom";

import LoggedIn from "./LoggedIn";
import LoggedOut from "./LoggedOut";

import { isUser } from "./utils/common";

import "./App.css";

const App = () => (
  <Route path="/" component={isUser() ? LoggedIn : LoggedOut} />
);

export default App;
